import buildItemComponent from "../../common/item-component-hoc"

import NotificationViewItemContainer from "./view/NotificationViewItemContainer"
import NotificationViewFormActionButtonsWidgetContainer from "./view/NotificationViewFormActionButtonsWidgetContainer"
import NotificationEditItemContainer from "./edit/NotificationEditItemContainer"
import NotificationEditFormActionButtonsWidgetContainer from "./edit/NotificationEditFormActionButtonsWidgetContainer"

const Notification = buildItemComponent("notifications", {
    view: [
        NotificationViewFormActionButtonsWidgetContainer,
        NotificationViewItemContainer,
    ],
    edit: [
        NotificationEditFormActionButtonsWidgetContainer,
        NotificationEditItemContainer,
    ],
})

export default Notification
